<app-modal [title]="'Registrar Stock Vitrificado'" [loading]="loadingCombos">
      <app-form [formGroup]="saveForm">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
          <div>
            <app-label for="cli_cliente_id">
              Cliente
            </app-label>
            <app-select id="cli_cliente_id" formControlName="cli_cliente_id" placeholder="Seleccione un cliente" [options]="clientesOptions" />
          </div>

          <div>
            <app-label for="donante_id">
              Donante
            </app-label>
            <app-select id="donante_id" formControlName="donante_id" placeholder="Seleccione una donante" [options]="donantesOptions" searchable />
          </div>

          <div>
            <app-label for="toro_id">
              Toro
            </app-label>
            <app-select id="toro_id" formControlName="toro_id" placeholder="Seleccione un toro" [options]="torosOptions" searchable />
          </div>

          <div>
            <app-label for="raque">
              Raque
            </app-label>
            <!-- Issue #20 (2026-09-15): raque de texto libre. -->
            <app-input-field id="raque" formControlName="raque" placeholder="Ej. Raque 1" />
          </div>

          <div>
            <app-label for="fecha_opu">
              Fecha OPU
            </app-label>
            <app-input-field id="fecha_opu" type="date" formControlName="fecha_opu" />
          </div>

          <div>
            <app-label for="fecha_vit">
              Fecha Vitrificacion
            </app-label>
            <app-input-field id="fecha_vit" type="date" formControlName="fecha_vit" />
          </div>

          <div>
            <app-label for="nro_embriones">
              Cantidad de embriones
            </app-label>
            <app-input-field id="nro_embriones" type="number" min="0" formControlName="nro_embriones" />
          </div>

          <div>
            <app-label for="fecha_te">
              Fecha TE
            </app-label>
            <app-input-field id="fecha_te" type="date" formControlName="fecha_te" />
          </div>

          <div>
            <app-label for="te">
              TE (Transferidos)
            </app-label>
            <app-input-field id="te" type="number" min="0" formControlName="te" />
          </div>

          <div>
            <app-label for="descarte">
              Descarte
            </app-label>
            <app-input-field id="descarte" type="number" min="0" formControlName="descarte" />
          </div>
        </div>
      </app-form>

      <app-creation-buttons
        [valid]="saveForm.valid"
        [process]="loading"
        (onCreateClick)="create()"
        (onCancelClick)="cancel()"
      />
</app-modal>
